import { render, staticRenderFns } from "./DivD.vue?vue&type=template&id=f727d81c&scoped=true"
import script from "./DivD.vue?vue&type=script&lang=js"
export * from "./DivD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f727d81c",
  null
  
)

export default component.exports